<template lang="pug">
  e-chart(
  :header="`${documentTitle}`"
  :options="chartGarbageOutputOptions"
  :series="chartGarbageOutputSeries"
  chartId="garbageOutput"
  :chartRedirectParams="chartRedirectParams"
  :chartLoading="chartLoading"
  :chartError="chartError"
  )
    template(slot="chartHeader")
      .default-select.part-1-from-4
        e-select(
        class="dropdown-btn"
        tabView="tab1"
        :model="fields"
        name="garbageOutputYear"
        :options="chartYearOptions"
        )


</template>
<script>
  import chartsMixin from '../mixins/charts-mixin.js'
  import {grey} from '../utils/chartOptionsData'

  export default {
    mixins: [chartsMixin],
    created () {
      this.fetchData()
    },
    watch: {
      'fields.garbageOutput.viewMode': {
        handler: function(v) {
          this.viewMode = v
          this.fetchData()
        }
      },
      'fields.garbageOutputYear': 'fetchData',
    },
    computed: {
      viewMode: {
        get: function () {
          return this.$store.getters.charts.garbageOutput.viewMode
        },
        set: function (newValue) {
          this.$store.commit('charts', {garbageOutput: {viewMode: newValue}})
        },
      },
      getCurrentChartOptions () {
        return this.getChartOptions('garbageOutput')
      }
    },
    methods: {
      buildEndpoint () {
        return this.getEndpoint()({
          query: {
            type: 'output',
            year: this.fields.garbageOutputYear,
            viewMode: this.viewMode
          }
        })
      },
      fetchData () {
        this.fetchChartData().then(r => {
          this.chartGarbageOutputSeries = this.transform(r)
        })
      },
      transform (response) {
        let data = []
        if (response.data && response.data.data && response.data.data.series) {
          response.data.data.series.forEach(v => {
            if(v.name && v.name === 'Не распределено'){
              data.push({
                name: v.name,
                y: +v.y,
                data: +v.data,
                color: grey
              })
            } else {
              data.push({
                name: v.name,
                y: +v.y,
                data: +v.data
              })
            }
          })
        }
        data.total_garbage_sum = response.data.data.total_garbage_sum
        return [{data}]
      }
    }
  }
</script>

<style>
  .pie-donut-caption {
    path: 'src/app/analytic/components/chart-garbage-output.vue';
    font-size: 38px;
  }
</style>
